import { PortalNewsPageObjClass } from "scrivito/Objs/PortalNewsPage/PortalNewsPageObjClass"

export function getPrimaryPortalNewsPage() {
  return PortalNewsPageObjClass.where("isPrimary", "equals", true).first()
}
